export default __webpack_public_path__ + "static/media/tags-stack.cc49dcfe.svg";